import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import ProjectOfflineInvestorsFormContainer
  from 'src/modules/project/update/partials/round-information/ProjectOfflineInvestorsForm.container';
import ProjectData from 'src/value-objects/ProjectData';
import ImageContainer from 'src/modules/commons/images/Image.container';
import { baseApiRoute } from 'src/resources/const';
import RichEditContainer from 'src/modules/commons/inputs/rich-edit/RichEdit.container';

export interface ProjectRoundDetailsFormComponentProps {
  formData: ProjectData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleRichEditor: (key: string) => (html: string) => void;
}

class ProjectRoundDetailsFormComponent extends React.Component<ProjectRoundDetailsFormComponentProps> {

  public render(): React.ReactNode {

    const minCash = this.props.formData.ticketValue * Math.ceil(parseFloat(
      (0.9 * (Math.round(this.props.formData.cashTarget / this.props.formData.ticketValue))).toFixed(0)
    ));

    const maxCash = this.props.formData.ticketValue * Math.floor(parseFloat(
      (1.25 * (Math.round(this.props.formData.cashTarget / this.props.formData.ticketValue))).toFixed(0)
    ));
    const postMoneyMin = this.props.formData.cashTarget * 0.9 + this.props.formData.premoneyValuation +
      this.props.formData.coInvestorsInvest;
    const postMoneyMax = this.props.formData.cashTarget * 1.25 + this.props.formData.premoneyValuation +
      this.props.formData.coInvestorsInvest;
    const MinPercent = (this.props.formData.cashTarget * 0.9 / postMoneyMin * 100).toFixed(2);
    const MaxPercent = (this.props.formData.cashTarget * 1.25 / postMoneyMax * 100).toFixed(2);

    return (

      <div>
        <p className="f-s-26">
          Detalles de la ronda
        </p>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-md-12">
            <RichEditContainer
              onChange={(value) => this.props.handleRichEditor('roundDetails')(value)}
              placeholder="Añade los detalles de la ronda"
              uploadURL={baseApiRoute + '/save-image'}
              value={this.props.formData.roundDetails}
            />
            <div className="gap-20"/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h5 className="deco-title f-s-18">
              Estructura de la ronda
            </h5>
            <div className="gap-20"/>
          </div>
          <div className="col-sm-4 col-md-4">
            <div className="md-input">
              <InputContainer
                label="Valoración Pre-money"
                type="number"
                value={this.props.formData.premoneyValuation.toString() || ''}
                onChange={(value) => this.props.handleChange('premoneyValuation')(value)}
                required={true}
              />
              <span className="euro-input icon-error-input"/>
            </div>
            <div className="gap-20"/>
          </div>
          <div className="col-sm-4 col-md-4">
            <div className="md-input disabled">
              <InputContainer
                label="Financiación pública"
                type="number"
                value={''}
                onChange={(value) => this.props.handleChange('')(value)}
                required={true}
              />
              <span className="euro-input icon-error-input"/>
            </div>
            <div className="gap-20"/>
          </div>
          <div className="col-md-8">
            <p className="f-s-16">
              <strong>
                1.- Inversor - <span className="c-primary"><em>The Crowd Angel</em></span>
              </strong>
            </p>
            <div className="gap-20"/>
            <div className="col-sm-6 col-md-6">
              <div className="md-input disabled">
                <InputContainer
                  label="Nombre del inversor"
                  type="text"
                  value="The Crowd Angel"
                  onChange={(value) => this.props.handleChange('')(value)}
                  required={true}
                  readOnly={true}
                />
                <span className="euro-input icon-error-input"/>
              </div>
              <div className="gap-10"/>
            </div>
            <div className="col-sm-6 col-md-6">
              <div className="md-input disabled">
                <InputContainer
                  label="Tipo de inversión"
                  type="text"
                  value="Cash"
                  onChange={(value) => this.props.handleChange('')(value)}
                  required={true}
                  readOnly={true}
                />
              </div>
              <div className="gap-10"/>
            </div>
            <div className="col-sm-6 col-md-6">
              <div className="md-input">
                <InputContainer
                  label="Capital a financiar"
                  type="number"
                  value={this.props.formData.cashTarget.toString() || ''}
                  onChange={(value) => this.props.handleChange('cashTarget')(value)}
                  required={true}
                />
                <span className="euro-input icon-error-input"/>
              </div>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="col-md-4">
            <div className="grey-box c-grey">
              <p>
                <strong>Detalles de la ronda</strong>
              </p>
              <p>
                Rango de Ampliación en TCA:
                <br/>
                <strong>
                  Mín {minCash} €
                  -
                  Máx {maxCash} €
                </strong>
              </p>
              <p>
                Porcentaje de equity TCA:
                <br/>
                <strong>
                  Mín {MinPercent}% -
                  Máx {MaxPercent}%</strong>
              </p>
            </div>
          </div>
        </div>
        <ProjectOfflineInvestorsFormContainer
          project={this.props.formData}
        />
        <div className="row">
          <div className="col-md-12">
            <h5 className="deco-title f-s-18">
              Inversor destacado
            </h5>
            <div className="gap-20"/>
          </div>
          <div className="col-md-6">
            <div className="row padding-l-r-10">
              <div className="md-input">
                <InputContainer
                  label="Nombre"
                  type="text"
                  value={this.props.formData.highlightInvestorName || ''}
                  onChange={(value) => this.props.handleChange('highlightInvestorName')(value)}
                  required={false}
                />
              </div>
            </div>
            <div className="row padding-l-r-10">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('highlightInvestorImage')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*"
              >
                <ImageContainer
                  alt="environment image"
                  url={
                    (this.props.formData.highlightInvestorImage && !this.props.formData.highlightInvestorImage.encoded)
                      ? this.props.formData.highlightInvestorImage.url : ''
                  }
                  defaultImagePath={
                    this.props.formData.highlightInvestorImage ?
                      this.props.formData.highlightInvestorImage.url :
                      '/img/pic.png'
                  }
                />
                <div className="gap-10"/>
                <p className="text-center">
                  Arrastre una foto / Clique aquí...
                </p>
              </ReactDropzone>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row padding-left-20">
              <p className="c-grey-dark f-s-16">Descripción</p>
              <RichEditContainer
                onChange={(value) => this.props.handleRichEditor('highlightInvestorDescription')(value)}
                placeholder="Añade la descripción del inversor"
                uploadURL={baseApiRoute + '/save-image'}
                value={this.props.formData.highlightInvestorDescription}
              />
            </div>
          </div>
        </div>
        <div className="gap-20"/>
      </div>
    );
  }
}

export default ProjectRoundDetailsFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectRoundDetailsForm.component.tsx